export default "__VITE_ASSET__DC5XAGCz__"